export enum TableColumnsNames {
  Violations = 'violations',
  Inventory = 'inventory',
  Hygiene = 'hygiene',
  PlaybooksExecutionsHistory = 'playbooksExecutionsHistory',
  DataLayer = 'dataLayer',
  AuditLogEvents = 'auditLogEvents',
  AccessGroups = 'accessGroups',
}

// Increment this version when column definitions change (e.g., column types, new columns)
// This triggers a merge of user preferences with fresh column definitions
export const TABLE_COLUMNS_VERSION = 3;
